export const getForcedViewParams = (view) => {
  switch (view) {
    case 'portrait':
      return { imagePreset: 'productCard--portrait', breakpoint: '0' };
    case 'landscape':
      return { imagePreset: 'productCard--landscape', breakpoint: null };
    default:
      return { imagePreset: 'productCard', breakpoint: 'tab' };
  }
};

export default {};
